module.exports = __webpack_public_path__ + "img/Lorinthe-Icon-semi-transparant.56f8050a.svg";